// ============================================================
// 딸(초4)이 직접 만지는 설정 파일.
// 숫자만 바꿔도 게임이 바뀝니다. 따옴표 안의 글자나 따옴표는 지우지 마세요!
// ============================================================

import type { PoolKey } from './types.js';

export const CONFIG = {
  // 지구본 회전 속도 (도/초). 0이면 멈춤. 작을수록 천천히.
  globeRotateSpeed: 6,

  // 한 라운드에 낼 문제 수 (고정)
  questionsPerRound: 10,

  // 이름 모드 객관식 보기 개수 (정답 1 + 오답 N-1, 고정)
  choiceCount: 4,

  // 위치 모드 보기 수 범위 — 매 문제마다 이 범위 안에서 랜덤으로 정해진다.
  // 같은 라운드 안에서도 문제마다 들쭉날쭉 (학습 다양성 ↑).
  locationChoiceMin: 2,
  locationChoiceMax: 4,

  // 출제 풀:
  //   'easy'             — 쉬운 나라 ~30개
  //   'East-South Asia'  — 동·동남·남아시아
  //   'West-Central Asia' — 서·중앙아시아 (스탄국·중동·코카서스)
  //   'Europe' | 'Africa' | 'North America' | 'South America' | 'Oceania'
  pool: 'easy' as PoolKey,

  // 제한시간 (고정 10초). 끄려면 enabled: false.
  timeLimit: {
    enabled: true,
    seconds: 10,
  },

  // 오답 시 정답 위치를 잠깐 보여줄 시간 (밀리초). 이름 모드 기본값.
  showAnswerOnWrongMs: 1500,

  // 위치 모드는 정답 위치를 시각적으로 인지·기억할 시간이 더 필요.
  locationShowAnswerOnWrongMs: 2500,

  // 정답 표시 후 다음 문제까지 대기 (밀리초)
  betweenQuestionsMs: 700,

  // 정답일 때 국가 색
  colors: {
    highlight: '#ffd54a',      // 출제된 국가 (노랑)
    correct: '#4caf50',        // 정답 피드백 (초록)
    wrong: '#f44336',          // 오답 피드백 (빨강)
    answerOnWrong: '#2196f3',  // 오답일 때 진짜 정답 위치 (파랑)
    baseLand: '#e0e0e0',       // 평소 육지 색 (현재 미사용 — 텍스처 그대로 노출)
    baseStroke: '#1a1a1a',     // 국경선 색 (지구본 텍스처 위에서 잘 보이도록 어둡게)
  },

  // 국가가 솟아오르는 높이 (지구 반지름 비율). 0.0 ~ 0.2 정도
  highlightAltitude: 0.06,
} as const;

export type AppConfig = typeof CONFIG;
